/**
 * Normalize an axios / FastAPI error response into a single user-facing string.
 * FastAPI returns 422 validation errors as an array of {msg,...} objects, which
 * crashes React if rendered directly.
 */
export function formatApiErrorDetail(detail, fallback = "Something went wrong. Please try again.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(", ");
  }
  if (typeof detail === "object" && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function extractAxiosError(err, fallback) {
  return formatApiErrorDetail(err?.response?.data?.detail, fallback);
}
